<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12" class="mb-10">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
          <h3>Refresh Data - Campaigns</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button @click="refreshAllCampaignDatas">Refresh All</vs-button>
        </vs-col>
      </vs-row>
      <DataGrid :context="'RefreshSDDATA'" :rowSelection="'single'" ref="campaignsList" :columnDefs="campaignsColumnDefs" :rowData="campaignsRecords"
        :dataSource="campaignsDataSource" @openPopulateDataPopUp="openPopulateDataPopUp" @refreshValidatePopulateDataPopUp="refreshValidatePopulateDataPopUp">
      </DataGrid>
    </vx-card>

    <vs-popup title="UnReviewed Sales Developer Data" :active.sync="UnReviewedSalesDeveloperDataPopUp">

      <div>
        <h6 class="text-center"> Listed below the campaigns which are in under reviewed. </h6>
        <h6 class="text-center"> Please review the data changes and refresh again. </h6>

      </div>
      <div>
      </div>

      <div class="vx-row p-5" v-if="unreviewed_campaigns">

        <div class="vx-col w-full">

          <div v-for="unreviewed_campaign,index in unreviewed_campaigns">


            <h6 class="ml-5">{{index + 1}} . <a class="pointer"
                @click="gotoReviewPage(unreviewed_campaign)">{{unreviewed_campaign['camp_name']}}</a></h6>
            <vs-divider class="p-1" />

          </div>
        </div>


      </div>

      <vs-row vs-w="12" v-if="refreshInBulk">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
          <vs-button @click="refreshReviewedCampaignData">Refresh</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="6" vs-sm="6" vs-xs="6">
          <vs-button @click="UnReviewedSalesDeveloperDataPopUp=false">Exit</vs-button>
        </vs-col>

      </vs-row>

    </vs-popup>




  </div>
</template>

<script>
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignFieldsManagement from "@/store/fields-management/campaign-fields-management/moduleCampaignFieldsManagement.js";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vSelect from "vue-select";
import axios from "@/axios.js";
export default {
  data: () => ({
            user_id: null,

    refreshInBulk: true,
    allCampaigns: [],
    unreviewed_campaigns: [],
    UnReviewedSalesDeveloperDataPopUp: false,
    abilities: null,
    campaignsColumnDefs: [
      {
        headerName: "Actions",
        field: "transactions",
        cellRenderer: "CellRendererActions",
        suppressHeaderMenuButton: true,
        pinned: true,
        width: 60
      },
      {
        headerName: "Campaign",
        field: "camp_name",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Campaign Code",
        field: "campaign_code",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Start Date",
        field: "start_date",
        flex: 1,

        filter: "agDateColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "End Date",
        field: "end_date",
        filter: "agDateColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      }
    ],
    campaignsRecords: [],
    selected_campaign: null
  }),
  components: {
    "v-select": vSelect,
    moduleCampaignFieldsManagement,
    DataGrid
  },
  watch: {},
  methods: {
    gotoReviewPage(campaign) {

      if (campaign) {
        this.UnReviewedSalesDeveloperDataPopUp = false
      }

      this.$router.push({
        path: "/quality_control/review_data/" + campaign.campaign_id + '/' + btoa(campaign.campaign_name)
      });

    },
    refreshReviewedCampaignData() {
      let self = this;
      self.UnReviewedSalesDeveloperDataPopUp = false
      self.$store
        .dispatch(
          "campaignsManagement/getUnReviewedCampaigns",
        )
        .then(function (response) {
          let response_data = JSON.parse(response.data);
          let all_campaigns = self.allCampaigns
          let unreviewed_campaigns = response_data

          let remaining_reviewed_campaigns = all_campaigns.filter(o1 => !unreviewed_campaigns.some(o2 => o1.campaign_id === o2.campaign_id));
          remaining_reviewed_campaigns.forEach(element => {
            self.refreshAllData(element)
          });
        })



    },
    refreshAllCampaignDatas() {
      let self = this;
      self.refreshInBulk = true
      self.$store
        .dispatch(
          "campaignsManagement/getUnReviewedCampaigns",
        )
        .then(function (response) {
          let response_data = JSON.parse(response.data);
          if (response_data.length != 0) {
            self.unreviewed_campaigns = response_data


            const key = 'campaign_id';

            self.unreviewed_campaigns = [...new Map(self.unreviewed_campaigns.map(item =>
              [item[key], item])).values()];



            self.UnReviewedSalesDeveloperDataPopUp = true
          }
          else {
            self.allCampaigns.forEach(element => {
              self.refreshAllData(element)
            });
            self.UnReviewedSalesDeveloperDataPopUp = false
          }
        })


    },
    refreshAllData(selected_campaign) {

      let self = this;
      self.$vs.loading();
      self.$store
        .dispatch("campaignsManagement/refreshDataSDData", selected_campaign.campaign_id)
        .then(res => {
          console.log(res.data)


          if (res.data.status == "success") {
            self.$vs.notify({
              color: "success",
              title: "Refresh Data",
              text: res.data.message
            });

            self.refreshValidateSDAccountDataWithMasterDB(selected_campaign)

            
          }else{

            self.$vs.notify({
              color: "failed",
              title: "Refresh Data",
              text: res.data.message
            });
            
          }
          self.$vs.loading.close();

        })
        .catch(err => {
          console.log(err);
        });
    },
     refreshValidateSDAccountDataWithMasterDB(selected_campaign) {
      let self = this;
      this.$store
        .dispatch("campaignsManagement/refreshValidateSDAccountDataWithMasterDB", selected_campaign.campaign_id)
        .then(res => {
          if (res.data.status == "success") {

               if (res.data.data > 0) {
              let link = "/campaigns/refreshValidateSDAccountDataWithMasterDBView/" + selected_campaign.campaign_id;
              let message = 'There are ' + res.data.data + ' accounts with different values after refresh data. Please review with the link below: <br> <a href ="' + window.location.origin + link + '" target="_blank"> Review Accounts</a>';

              let subject = "Refresh " + selected_campaign.campaign_name + " Account Data To SD Table";

              self.sendCompletedEmail(message, subject)



            } else {

              let message = "There are no accounts with different values after refresh data. Please click on the link below to view the accounts on the campaign: <br> <a href ='" + window.location.origin + "/accounts/matched/" + selected_campaign.campaign_id + '/' + btoa(selected_campaign.campaign_name) + "' target='_blank'>View Campaign Accounts</a>";

              let subject = "Refresh " + selected_campaign.campaign_name + " Account Data To SD Table";

              self.sendCompletedEmail(message, subject)


            }


              self.refreshValidateAccountClientViewDataWithMasterDB(selected_campaign)
       
           
            
          }
          else{

             let message = 'There is something wrong with the update. Please contact support team.';

              let subject = "Refresh " + selected_campaign.campaign_name + " Account Data To SD Table";

              self.sendCompletedEmail(message, subject)



          }
        })
        .catch(err => {     
          console.log(err);     
            });
          },
           refreshValidateAccountClientViewDataWithMasterDB(selected_campaign) {
      let self = this;
      this.$store
        .dispatch("campaignsManagement/refreshValidateAccountClientViewDataWithMasterDB", selected_campaign.campaign_id)
        .then(res => {
          if (res.data.status == "success") {

               if (res.data.data > 0) {
              let link = "/campaigns/refreshValidateClientViewAccountDataWithMasterDBView/" + selected_campaign.campaign_id;
              let message = 'There are ' + res.data.data + ' accounts with different values after refresh data. Please review with the link below: <br> <a href ="' + window.location.origin + link + '" target="_blank"> Review Accounts</a>';

              let subject = "Refresh " + selected_campaign.campaign_name + " Account Data To Client View Table";

              self.sendCompletedEmail(message, subject)



            } else {

              let message = "There are no accounts with different values after refresh data. Please click on the link below to view the accounts on the campaign: <br> <a href ='" + window.location.origin + "/accounts/matched/" + selected_campaign.campaign_id + '/' + btoa(selected_campaign.campaign_name) + "' target='_blank'>View Campaign Accounts</a>";

              let subject = "Refresh " + selected_campaign.campaign_name + " Account Data To Client View Table";

              self.sendCompletedEmail(message, subject)


            }

              self.refreshValidateSDContactDataWithMasterDB(selected_campaign)

           
            
          }
          else{

             let message = 'There is something wrong with the update. Please contact support team.';

              let subject = "Refresh " + selected_campaign.campaign_name + " Account Data";

              self.sendCompletedEmail(message, subject)



          }
        })
        .catch(err => {     
          console.log(err);     
            });
          },
           refreshValidateSDContactDataWithMasterDB(selected_campaign) {
      let self = this;
      this.$store
        .dispatch("campaignsManagement/refreshValidateSDContactDataWithMasterDB", selected_campaign.campaign_id)
        .then(res => {
          if (res.data.status == "success") {

               if (res.data.data > 0) {
              let link = "/campaigns/refreshValidateSDContactDataWithMasterDBView/" + selected_campaign.campaign_id;
              let message = 'There are ' + res.data.data + ' contacts with different values after refresh data. Please review with the link below: <br> <a href ="' + window.location.origin + link + '" target="_blank"> Review Contacts</a>';

              let subject = "Refresh " + selected_campaign.campaign_name + " Contact Data To SD Table";

              self.sendCompletedEmail(message, subject)



            } else {

              let message = "There are no contacts with different values after refresh data. Please click on the link below to view the contacts on the campaign: <br> <a href ='" + window.location.origin + "/accounts/matched/" + selected_campaign.campaign_id + '/' + btoa(selected_campaign.campaign_name) + "' target='_blank'>View Campaign Contacts</a>";

              let subject = "Refresh " + selected_campaign.campaign_name + " Contact Data To SD Table";

              self.sendCompletedEmail(message, subject)


            }

                      self.refreshValidateContactClientViewDataWithMasterDB(selected_campaign)


           
            
          }
          else{

             let message = 'There is something wrong with the update. Please contact support team.';

              let subject = "Refresh " + selected_campaign.campaign_name + " Contact Data";

              self.sendCompletedEmail(message, subject)



          }
        })
        .catch(err => {     
          console.log(err);     
            });
          },
           refreshValidateContactClientViewDataWithMasterDB(selected_campaign) {
      let self = this;
      this.$store
        .dispatch("campaignsManagement/refreshValidateContactClientViewDataWithMasterDB", selected_campaign.campaign_id)
        .then(res => {
          if (res.data.status == "success") {

               if (res.data.data > 0) {
              let link = "/campaigns/refreshValidateClientViewContactDataWithMasterDBView/" + selected_campaign.campaign_id;
              let message = 'There are ' + res.data.data + ' contacts with different values after refresh data. Please review with the link below: <br> <a href ="' + window.location.origin + link + '" target="_blank"> Review Contacts</a>';

              let subject = "Refresh " + selected_campaign.campaign_name + " Contact Data To Client View Table";

              self.sendCompletedEmail(message, subject)



            } else {

              let message = "There are no contacts with different values after refresh data. Please click on the link below to view the contacts on the campaign: <br> <a href ='" + window.location.origin + "/accounts/matched/" + selected_campaign.campaign_id + '/' + btoa(selected_campaign.campaign_name) + "' target='_blank'>View Campaign Contacts</a>";

              let subject = "Refresh " + selected_campaign.campaign_name + " Contact Data To Client View Table";

            self.sendCompletedEmail(message, subject)


            }

           
            
          }
          else{

             let message = 'There is something wrong with the update. Please contact support team.';

              let subject = "Refresh " + selected_campaign.campaign_name + " Contact Data To Client View Table";

              self.sendCompletedEmail(message, subject)



          }
        })
        .catch(err => {     
          console.log(err);     
            });
          },
    wait(ms){
   var start = new Date().getTime();
   var end = start;
   while(end < start + ms) {
     end = new Date().getTime();
  }
},
    sendCompletedEmail(message , subject){

       let self = this
        let data = {}
        data.user_id = self.user_id
        data.message = message
        data.subject = subject

self.wait(5000);  //7 seconds in milliseconds

     
            axios
        .post(
          self.$base_url + "/api/contacts/send_completed_email",
          data
        )
        .then(response => {
          if (response.data.status == "success") {
            self.$vs.notify({
              color: "success",
              title: "Data Validation",
              text: "The data validation email has been sent successfully."
            });
          }
        })
        .catch(error => {
          console.log(error);
        });


        
       
        
    },
    refreshData() {
      // this.$vs.loading();

      let campaign_id = this.selected_campaign_id;
      let self = this;

      self.$store
        .dispatch("campaignsManagement/refreshDataSDData", campaign_id)
        .then(res => {
          if (res.data.status == "success") {
            console.log(res.data.data)
            self.$vs.notify({
              color: "success",
              title: "Refresh Data",
              text: res.data.message
            });
            this.$vs.loading.close();

            this.$refs.campaignsList.gridApi.refreshServerSide({purge : true});
          } else {
            self.$vs.notify({
              color: "danger",
              title: "Refresh Data",
              text: res.data.message
            });
            this.$vs.loading.close();
            this.$router.replace("/campaigns/add-more-field");
          }
        })
        .catch(err => {
          console.log(err);
        });


      console.log("Submitted");
    },
    refreshValidatePopulateDataPopUp(value) {

      this.$router.replace("/campaigns/refreshValidate-sd-and-master-db-data/" + campaign_id);


            this.$vs.loading();

      let campaign_id = value.campaign_id
      let self = this;


      alert(campaign_id)
      self.$store
        .dispatch("campaignsManagement/refreshValidateSDAndMasterDbData", campaign_id)
        .then(res => {


          console.log(res.data)

          if (res.data.status == "success") {



            // self.$vs.notify({
            //   color: "success",
            //   title: "Refresh Data",
            //   text: res.data.message
            // });
            this.$vs.loading.close();

            // this.$refs.campaignsList.gridApi.refreshServerSide({purge : true});
          } else {
            self.$vs.notify({
              color: "danger",
              title: "Refresh Data",
              text: res.data.message
            });
            this.$vs.loading.close();
            this.$router.replace("/campaigns/add-more-field");
          }
        })
        .catch(err => {
          console.log(err);
        });


      console.log("Submitted");


     console.log(value)
    },
     openPopulateDataPopUp(value) {
      let self = this;
            self.$vs.loading();
      self.selected_campaign = value;
      self.selected_campaign_id = value.campaign_id;

      self.$store
        .dispatch(
          "campaignsManagement/getUnReviewedCampaigns",
        )
        .then(function (response) {
          let response_data = JSON.parse(response.data);
          self.unreviewed_campaigns = []
          self.refreshInBulk = false

          if(response_data.length == 0){
            self.refreshAllData(self.selected_campaign)
              self.UnReviewedSalesDeveloperDataPopUp = false
          }else{
            response_data.forEach(element => {
            if (element.campaign_id == self.selected_campaign_id) {
              self.unreviewed_campaigns.push(element)
              self.UnReviewedSalesDeveloperDataPopUp = true
            } 

          });


             if(self.unreviewed_campaigns.length == 0){
              self.refreshAllData(self.selected_campaign)
              self.UnReviewedSalesDeveloperDataPopUp = false
            }else{
              self.UnReviewedSalesDeveloperDataPopUp = true
            }

          }


self.$vs.loading.close();

       


        
        })


    },
    //   let self = this;
    //   self.selected_campaign = value;
    //   self.selected_campaign_id = value.campaign_id;

    //   self.$store
    //     .dispatch(
    //       "campaignsManagement/getUnReviewedCampaigns",
    //     )
    //     .then(function (response) {
    //       let response_data = JSON.parse(response.data);
    //       self.unreviewed_campaigns = []
    //       self.refreshInBulk = false

    //       if(response_data.length == 0){
    //         self.refreshAllData(self.selected_campaign_id)
    //           self.UnReviewedSalesDeveloperDataPopUp = false
    //       }else{
    //         response_data.forEach(element => {
    //         if (element.campaign_id == self.selected_campaign_id) {
    //           self.unreviewed_campaigns.push(element)
    //           self.UnReviewedSalesDeveloperDataPopUp = true
    //         } 

    //       });

    //       }



    //       if(self.unreviewed_campaigns.length == 0 && response_data.length != 0){
    //           self.refreshAllData(self.selected_campaign_id)
    //           self.UnReviewedSalesDeveloperDataPopUp = true
    //         }else{
    //           self.UnReviewedSalesDeveloperDataPopUp = false
    //         }

        
    //     })


    //   // this.refreshData();
    // },
    getcampaignDataSource() {
      var self = this;

      this.campaignsDataSource = {
        getRows(params) {
          self.$store
            .dispatch(
              "campaignsManagement/getAllCampaignsForGridForPopulateData",
              params.request
            )
            .then(function (response) {
              let response_data = response.rows;
              self.allCampaigns = response_data
              console.log("Campaigns", response_data);
              if (response_data.length != 0) {
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function () {
      this.$router.go(-1);
    }
  },
  beforeMount() {
    this.getcampaignDataSource();
  },
  mounted() { },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
     let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    if (!moduleCampaignFieldsManagement.isRegistered) {
      this.$store.registerModule(
        "CampaignFieldsManagement",
        moduleCampaignFieldsManagement
      );
      moduleCampaignFieldsManagement.isRegistered = true;
    }
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.pointer {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-Fields
  .con-btns-Fields
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Fieldsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
